import {
  validateCUIT as validateCUITShared,
  validateEmail as validateEmailShared,
  validatePhone as validatePhoneShared,
} from '../../../utils/validationUtils';

/**
 * Filtra entidades legales por término de búsqueda
 * @param {Array} legalEntities - Lista de entidades legales
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Array} - Entidades legales filtradas
 */
export const filterLegalEntities = (legalEntities, searchTerm) => {
  if (!searchTerm.trim()) {
    return legalEntities;
  }

  const term = searchTerm.toLowerCase();
  return legalEntities.filter(
    (legalEntity) =>
      legalEntity.company?.toLowerCase().includes(term) ||
      legalEntity.cuit?.toLowerCase().includes(term) ||
      legalEntity.legal_business_name?.toLowerCase().includes(term)
  );
};

export const validateCUIT = (cuit) => validateCUITShared(cuit);

/**
 * Valida un email
 * @param {string} email - Email a validar
 * @returns {boolean} - True si es válido
 */
export const validateEmail = (email) => validateEmailShared(email, { optional: true });

/**
 * Valida un teléfono
 * @param {string} phone - Teléfono a validar
 * @returns {boolean} - True si es válido
 */
export const validatePhone = (phone) => validatePhoneShared(phone, { optional: true });

/**
 * Prepara los datos de la entidad legal para envío a la API
 * @param {Object} legalEntity - Datos de la entidad legal
 * @returns {Object} - Datos preparados para la API
 */
export const prepareLegalEntityData = (legalEntity) => {
  const cleanedData = { ...legalEntity };

  // Limpiar campos vacíos
  Object.keys(cleanedData).forEach((key) => {
    if (cleanedData[key] === '' || cleanedData[key] === null) {
      delete cleanedData[key];
    }
  });

  return cleanedData;
};

/**
 * Obtiene el nombre de un distrito por UUID
 * @param {Array} districts - Lista de distritos
 * @param {string} uuid - UUID del distrito
 * @returns {string} - Nombre del distrito
 */
export const getDistrictName = (districts, uuid) => {
  const district = districts?.find((d) => d.uuid === uuid);
  return district?.name || 'Sin distrito';
};

/**
 * Obtiene la ubicación completa de una entidad legal
 * @param {Object} legalEntity - Entidad legal
 * @param {Array} countries - Lista de países
 * @param {Array} provinces - Lista de provincias
 * @param {Array} departments - Lista de departamentos
 * @param {Array} districts - Lista de distritos
 * @returns {Object} - Ubicación completa
 */
export const getLegalEntityLocation = (
  legalEntity,
  countries,
  provinces,
  departments,
  districts
) => {
  const district = districts?.find((d) => d.uuid === legalEntity.uuid_district);
  const department = departments?.find((d) => d.uuid === district?.uuid_department);
  const province = provinces?.find((p) => p.uuid === department?.uuid_province);
  const country = countries?.find((c) => c.uuid === province?.uuid_country);

  return {
    district,
    department,
    province,
    country,
  };
};
